import { render } from "./TheMember.vue?vue&type=template&id=3e1c6c75"
import script from "./TheMember.vue?vue&type=script&lang=js"
export * from "./TheMember.vue?vue&type=script&lang=js"
script.render = render

export default script